export default {
  methods: {
    canAccessDashboardResource(resource) {
      // this will need to be expanded but the aim is to stop a navigation
      // item from showing is the top level items are not accessible
      let canAccess = true;
      if (resource.resourceType === 'NavigationGroup') {
        const navigationGroup = this.$store.getters['navigationGroups/navigationGroups'][resource.resourceId];
        const navigationItems = navigationGroup.navigationItems(this.$store);
        canAccess = navigationItems.some(navItem => this.canAccessResource(navItem));
      }
      return canAccess;
    },
    canAccessResource(resource) {
      let canAccess = false;

      if (resource.destination === 'catalog') {
        const user = this.$store.getters['user/get'];
        canAccess = user.catalogPricingEnabled;
      } else if (resource.resourceType === 'AppDashboard') {
        canAccess = this.canAccessDashboard(resource.resourceId);
      }
      return canAccess;
    },
    canAccessDashboard(dashboardId) {
      const dashboard = this.$store.getters['dashboards/get'][dashboardId];
      if (!dashboard) return false;

      if (dashboard?.hiddenShowOnPurchase) {
        return this.$access(this.$store, 'appDashboard', dashboard.id);
      } else {
        return true;
      }
    },
  },
};
